/**
 * Stripe Configuration
 * Handles environment-based Stripe key selection and configuration
 */

// Environment detection utility
const getEnvironment = () => {
  // Check if we're in development
  if (import.meta.env.DEV) {
    return 'test';
  }
  
  // Check for explicit environment override
  const gcpEnv = import.meta.env.VITE_GCP_ENV;
  if (gcpEnv === '-dev') {
    return 'test';
  }
  
  // Production environment
  return 'live';
};

// Get the appropriate Stripe publishable key for client-side use
export const getStripePublishableKey = () => {
  const env = getEnvironment();
  
  if (env === 'test') {
    return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_TEST;
  }
  
  return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY_LIVE;
};

// Get price IDs based on environment
export const getStripePriceIds = () => {
  const env = getEnvironment();
  
  if (env === 'test') {
    return {
      monthly: import.meta.env.STRIPE_PRICE_ID_MONTHLY_TEST,
      annual: import.meta.env.STRIPE_PRICE_ID_ANNUAL_TEST,
    };
  }
  
  return {
    monthly: import.meta.env.STRIPE_PRICE_ID_MONTHLY_LIVE,
    annual: import.meta.env.STRIPE_PRICE_ID_ANNUAL_LIVE,
  };
};

// Validate that required Stripe configuration is present
export const validateStripeConfig = () => {
  const publishableKey = getStripePublishableKey();
  
  if (!publishableKey) {
    throw new Error('Stripe publishable key is not configured for current environment');
  }
  
  const priceIds = getStripePriceIds();
  if (!priceIds.monthly || !priceIds.annual) {
    console.warn('Stripe price IDs are not fully configured for current environment');
  }
  
  return {
    publishableKey,
    priceIds,
    environment: getEnvironment(),
  };
};

// Export environment detection for use in API endpoints
export const isTestEnvironment = () => getEnvironment() === 'test';